import { Routes } from '@angular/router';

export const landingRoutes: Routes = [
  { path: '', loadComponent: () => import('../new-design/homepage/homepage.component').then(m => m.HomepageComponent) },
];
